const BorderGlowWrapper = ({ children }) => {
    return (
        <div className="relative p-[2px] rounded-[8px]">
            {/* 動態雷射光邊框 */}
            <div
                className="absolute inset-0 rounded-[8px] bg-[linear-gradient(270deg,#ff00ff,#49bfff,#ff00ff)] 
                           bg-[length:400%_400%] animate-glow shadow-[0_0_7px_rgba(255,255,255,0.5),0_0_7px_rgba(255,255,255,0.5)]"
                style={{ zIndex: 0 }}
            />
            <div className="relative z-[1] bg-black/20 rounded-[6px] overflow-hidden">
                {children}
            </div>
            <style jsx>{`
                @keyframes glow {
                    0% {
                        background-position: 0% 50%;
                    }
                    50% {
                        background-position: 100% 50%;
                    }
                    100% {
                        background-position: 0% 50%;
                    }
                }
                .animate-glow {
                    animation: glow 4s linear infinite;
                }
            `}</style>
        </div>
    );
};

export default BorderGlowWrapper;
